import { render, staticRenderFns } from "./DoubleImageVideo.vue?vue&type=template&id=fc74e6b8&"
import script from "./DoubleImageVideo.vue?vue&type=script&lang=js&"
export * from "./DoubleImageVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports